import { render, staticRenderFns } from "./serverError.vue?vue&type=template&id=a6b740f8&scoped=true"
import script from "./serverError.vue?vue&type=script&lang=js"
export * from "./serverError.vue?vue&type=script&lang=js"
import style0 from "./serverError.vue?vue&type=style&index=0&id=a6b740f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b740f8",
  null
  
)

export default component.exports